import { render, staticRenderFns } from "./orgComfirm.vue?vue&type=template&id=09c5e9d1&scoped=true"
import script from "./orgComfirm.vue?vue&type=script&lang=js"
export * from "./orgComfirm.vue?vue&type=script&lang=js"
import style0 from "./orgComfirm.vue?vue&type=style&index=0&id=09c5e9d1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09c5e9d1",
  null
  
)

export default component.exports